// @flow
import * as React from 'react'

import './HR.scss'

export default class HR extends React.Component<{}> {
  render = () => {
    return <hr className="HR" />
  }
}
